export const meta = {
  id: "FW-55",
  name: "Boltworks",
  slug: "boltworks",
  title: "Boltworks — a Fable World: hardware storefront",
  description:
    "An original hardware storefront designed by Fable: one fastening system that reassembles itself into every configuration as you scroll."
} as const;

export type WorldMeta = typeof meta;

/** The registry reads the NAMED export `meta`, and `meta.slug` must equal this directory. */
export default meta;
